module.exports = __webpack_public_path__ + "img/transparent-HQ.84070194.png";